<template>
  <div class="change-email">
    <div class="mdl-card mdl-shadow--2dp" v-if="state == 'done'">
      <div class="mdl-card__title mdl-color--primary">
        <h2 class="mdl-card__title-text">{{ i18n().done.title }}</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand">
        {{ i18n().done.text({email: newEmail}) }}
      </div>
    </div>
    <form class="mdl-card mdl-shadow--2dp" v-on:submit="change" v-if="state != 'done'">
      <div class="mdl-card__title mdl-color--primary">
        <h2 class="mdl-card__title-text">{{ i18n().title }}</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand">

        <div :class="{blurred: state=='working'}">
          <div class="serverError" v-if="error">{{ i18n().errors[error] || error }}</div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="email" id="newEmail" v-model="newEmail"
                   v-bind:required="required" ref="newEmail">
            <label class="mdl-textfield__label" for="newEmail">{{ i18n().newEmail }}</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="password" id="currentPassword" v-model="currentPassword"
                   v-bind:required="required" ref="currentPassword">
            <label class="mdl-textfield__label" for="currentPassword">{{ i18n().currentPassword }}</label>
          </div>

        </div>

        <div class="working" v-if="state == 'working'">
          <div class="mdl-spinner mdl-js-spinner is-active"></div>
        </div>

      </div>

      <div class="mdl-card__actions mdl-card--border" :class="{blurred: state=='working'}">
        <button type="submit" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
          {{ i18n().submit }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import api from "api"
  import i18n from "i18n"

  export default {
    name: 'change-email',
    data () {
      return {
        newEmail: '',
        currentPassword: '',
        state: 'ready',
        required: false,
        error: null
      }
    },
    methods: {
      i18n() { return i18n().emailPassword.startEmailChange },
      change(e) {
        e.preventDefault()

        if(this.newEmail.trim() == '') {
          this.required = true
          if(this.newEmail.trim()=='') {
            this.$refs.newEmail1.parentElement.setAttribute('class',
              this.$refs.newEmail1.parentElement.getAttribute('class') + ' is-invalid')
            this.$refs.newEmail1.focus()
          }
          return
        }

        this.state = "working"
        api.request(["emailPassword", "startEmailChange"], this.newEmail, this.currentPassword).then(result => {
          this.state = "done"
        }).catch(error => {
          this.error = error
          this.state = "ready"
        })
      }
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .change-email {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .mdl-card__actions button {
    float: right;
  }

  .blurred {
    filter: blur(2px) grayscale(50%);
  }

  .working {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    text-align: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
  }
  .working div {
    margin: auto;
    height: 5em;
    width: 5em;
  }

  .serverError {
    color: darkred;
  }

</style>



// WEBPACK FOOTER //
// ChangeEmail.vue?17d46e6d